import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "src/ipm-shared/components/GlobalUI/selectors";

import View from "./View";
import * as actions from "src/bepaid/store/model/Fetch/actions";

const mapStateToProps = (state: RootState, props: any) => ({
  countryCode: selectors.getAccountCountryCode(state),
  extraInfo: selectors.getExtraInfo(state, props.modalId)
});

const mapDispatchToProps = {
  addCustomer: actions.addCustomer
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(View);
